module.exports = __webpack_public_path__ + "media/country_flags/pt-3f85d389.png";